export default __webpack_public_path__ + "img/data-center.7b418423.png";